<template>
  <div
    class="pageFooterBottom onLineIndex"
    :style="{
      background: `linear-gradient(180deg, ${bgColor} 8%, var(--bgColor) 260px`,
    }"
  >
    <Header
      :title="$route.query.name"
      bgColor="transparent"
      :isShadow="false"
      :isFixed="false"
    />
    <!-- <div class="pageFontWeight tabTitle" slot="title">
      {{ $route.query.name }}
    </div> -->
    <div>
      <OilCardRecharge
        v-if="link === 'oilRecharge'"
        :couponsName="couponsName"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :mouldId="mouldId"
      />
      <MobileRecharge
        v-if="link === 'mobileBillRecharge' || link === 'mobileFlowRecharge'"
        :type="link"
        :couponsName="couponsName"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :mouldId="mouldId"
      />
      <JiaYouGuangDongRecharge
        v-if="link === 'oilGD'"
        :couponsName="couponsName"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :mouldId="mouldId"
      />
      <AudioRecharge
        v-if="
          link === 'videoRecharge' ||
          link === 'musicRecharge' ||
          link === 'wangyou' ||
          link === 'gouwuka'
        "
        :couponsName="couponsName"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :mouldId="mouldId"
      />
      <OnlineNsRecharge
        v-if="link === 'examined'"
        :type="link"
        :couponsName="couponsName"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
      />
      <Driving
        v-if="link === 'driving'"
        :couponsName="couponsName"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :ident="link"
        :mouldId="mouldId"
      />
      <ShoppingCard
        v-if="link === 'shoppingCard'"
        :couponsName="couponsName"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :mouldId="mouldId"
      />
      <CarCharging
        v-if="link === 'carCharging'"
        :couponsName="couponsName"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :mouldId="mouldId"
      />
      <AlipayRedPacket
        v-if="link === 'alipayRedPacket'"
        :couponsName="couponsName"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :ident="link"
        :mouldId="mouldId"
      />
      <TmallWash
        v-if="link === 'tmallWash'"
        :couponsName="couponsName"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :ident="link"
        :mouldId="mouldId"
      />
      <Parking
        v-if="link === 'parking'"
        :couponsName="couponsName"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :ident="link"
        :mouldId="mouldId"
      />
      <LifeService
        v-if="link === 'lifeService'"
        :couponsName="couponsName"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :mouldId="mouldId"
      />
      <Transport
        v-if="link === 'transport'"
        :couponsName="couponsName"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :mouldId="mouldId"
      />
      <OnlineEducation
        v-if="link === 'onlineEducation'"
        :couponsName="couponsName"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :mouldId="mouldId"
      />
      <WeChatRedPacket v-if="link === 'weChatPoints'" />
      <AlipayPoints
        v-if="link === 'alipayPoints'"
        :couponsName="couponsName"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :ident="link"
        :mouldId="mouldId"
      />
    </div>
    <!-- 卡券余额支付列表 -->
    <van-popup
      v-model="couponsBalanceShow"
      round
      position="bottom"
      class="couponsBalanceList"
    >
      <div class="van-coupon-list">
        <div class="van-tabs__content">
          <div role="tabpanel" class="van-tab__pane" style="">
            <div
              class="van-coupon-list__list van-coupon-list__list--with-bottom"
            >
              <van-checkbox-group
                v-model="couponsBalanceChecked"
                ref="checkboxGroup"
                @change="changeCheckboxes"
              >
                <div
                  class="van-coupon"
                  :style="item.is_can_use == 0 ? 'filter: grayscale(1);' : ''"
                  @click="toggle(index, item.couponsStatus)"
                  v-for="(item, index) in couponsBalanceList"
                  :key="index"
                >
                  <div class="van-coupon__content">
                    <div class="van-coupon__head">
                      <!-- <van-image :src="lgImg" width="32" height="32" /> -->
                      <van-icon class="iconfont iconqiaquanguanli" size="32" />
                    </div>
                    <div class="van-coupon__body">
                      <p class="van-coupon__name">
                        {{ item.couponsProductName }}
                      </p>
                      <p class="van-coupon__valid">
                        <!-- <span>ID：{{ item.couponsId }}</span> -->
                        <span>到期时间：{{ item.couponsEndDate }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="van-coupon__description">
                    <div class="left">
                      <p class="money">
                        余额
                        <span style="font-weight: 700; font-size: 16px">￥</span
                        ><span class="number">{{
                          $formatMoney(Number(item.couponsBalance), 2).split(
                            "."
                          )[0]
                        }}</span
                        ><span style="font-weight: 700; font-size: 18px"
                          >.{{
                            $formatMoney(Number(item.couponsBalance), 2).split(
                              "."
                            )[1]
                          }}</span
                        >
                      </p>
                      <!-- <p class="remark">备注：说明XXXXXXXX</p> -->
                    </div>
                    <div class="right">
                      <van-checkbox
                        checked-color="#f90"
                        ref="checkboxes"
                        :name="item"
                        :disabled="item.couponsStatus == 0 || item.disabled"
                        @click="checkboxclick"
                      ></van-checkbox>
                    </div>
                  </div>
                </div>
              </van-checkbox-group>
            </div>
          </div>
        </div>
        <div class="van-coupon-list__bottom" style="position: fixed">
          <button
            class="van-button van-button--danger van-button--normal van-button--block van-button--round van-coupon-list__close"
            @click="couponsBalanceShow = false"
          >
            <div class="van-button__content">
              <span class="van-button__text">确定</span>
            </div>
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import AudioRecharge from "./AudioRecharge";
import MobileRecharge from "./MobileRecharge";
import OilCardRecharge from "./OilCardRecharge";
import JiaYouGuangDongRecharge from "./JiaYouGuangDongRecharge";
import OnlineNsRecharge from "./OnlineNs";
import Driving from "./Driving";
import ShoppingCard from "./ShoppingCard";
import CarCharging from "./CarCharging";
import AlipayRedPacket from "./AlipayRedPacket";
import TmallWash from "./TmallWash";
import Parking from "./Parking";
import LifeService from "./LifeService";
import Transport from "./Transport";
import OnlineEducation from "./OnlineEducation";
import { getAllServerList, getValidCoupons } from "api/onLine";
import { getPhoneCode } from "api/user";
import { Dialog } from "vant";
import WeChatRedPacket from "./WeChatRedPacket.vue";
import AlipayPoints from "./AlipayPoints.vue";

export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    MobileRecharge,
    AudioRecharge,
    OilCardRecharge,
    JiaYouGuangDongRecharge,
    OnlineNsRecharge,
    Driving,
    ShoppingCard,
    CarCharging,
    AlipayRedPacket,
    TmallWash,
    Parking,
    LifeService,
    Transport,
    OnlineEducation,
    WeChatRedPacket,
    AlipayPoints
  },
  data() {
    return {
      bgColor: "var(--depYelColor)",
      lineWidth: "80px",
      active: 0,
      bgImg: require("assets/u2.png"),
      lgImg: require("assets/u10.png"),
      list: [],
      show: false,
      sms: "",
      phone: "",
      data: "",
      isDisabled: false,
      buttonText: "发送验证码",
      balance: 0,
      balanceChecked: false,
      payData: "",
      showDialogs: false,
      showDialogs2: false,
      radio: "",
      couponsName: "",
      isMember: false,
      couponType: 1,
      chosenCoupon: -1,
      coupons: [],
      disabledCoupons: [],
      chosenCoupon2: -1,
      coupons2: [],
      disabledCoupons2: [],
      couponsBalanceList: [],
      couponsBalanceShow: false,
      couponsBalanceChecked: [],
      couponsDeduct: 0,
      cards: "",
      sell_price: 0,
      number: -1,
      current_couponsBalance: 0,
      oldTitle: "",
      link: "",
      categoryId: 0,
      mouldId: 0,
      upstreamId: 0,
      buyerUserId: 0,
    };
  },
  created() {
    let logo = this.$getItem("logo");
    if ((logo != "") & (logo != undefined)) {
      this.lgImg = logo;
    }
    let ident = this.$route.query.ident;
    if (ident == "daijia") {
      this.couponType = 2;
    }
    this.setBackground(ident);
    this.link = this.$route.query.ident;
    this.categoryId = this.$route.query.categoryId;
    this.upstreamId = this.$route.query.upstreamId;
    this.buyerUserId = this.$route.query.buyerUserId;
    this.mouldId = this.$route.query.mouldId;
  },
  mounted() {
    this.getValidCoupons();
    // this.getUserInfo();
  },
  methods: {
    checkboxclick() {
      if (this.sell_price <= 0) {
        this.couponsBalanceChecked = [];
      }
    },
    changeCheckboxes(names) {
      let arryLists = "";
      let money = 0;
      for (let i = 0; i < names.length; i++) {
        const element = names[i];
        if (i == 0) {
          arryLists += element.couponsId;
        } else {
          arryLists += "," + element.couponsId;
        }
        money += Number(element.couponsBalance);
      }

      let remainder = 0
      let amount = 0
      //支付宝积分页，需要根据折扣计算金额
      if(this.link == "alipayPoints" && names.length > 0){
        amount = Number((this.sell_price / names[0].couponsWechatRedpacketRebate).toFixed(2))
      }else{
        amount = this.sell_price
      }
      remainder = amount - money;
      remainder = remainder > 0 ? money : amount;
      this.couponsDeduct = Number(remainder >= 0 ? remainder : 0);
      this.cards = arryLists;
      if (arryLists != "") {
        this.number = arryLists.split(",").length;
      } else {
        this.number = 0;
      }
    },
    toggle(index, is_can_use) {
      if (is_can_use == 0 || this.balanceChecked) {
        return;
      }
      if (this.sell_price <= 0) {
        if (this.link == "examined") {
          this.$error(
            this.chosenCoupon <= 0 ? "请先选择检测站和套餐" : "卡券已抵扣"
          );
          this.couponsBalanceShow = false;
          return;
        } else if (this.link == "onlineEducation") {
          this.$error(this.chosenCoupon <= 0 ? "请先选择视频" : "卡券已抵扣");
          this.couponsBalanceShow = false;
          return;
        }else if (this.link != "alipayPoints"){
          this.$error(this.chosenCoupon <= 0 ? "请先选择面值" : "卡券已抵扣");
          this.couponsBalanceShow = false;
        }
      }
      let now = this.$refs.checkboxes[index];
      let price = this.sell_price;
      let arry = this.couponsBalanceChecked;
      let sum = 0;
      for (let index = 0; index < arry.length; index++) {
        const element = arry[index];
        sum += Number(element.couponsBalance);
      }
      if (this.link != "alipayPoints" && sum >= price && !now.checked) {
        this.$error("当前已满足支付金额");
        return false;
      } else {
        now.toggle();
      }
    },
    onChange(index) {
      this.showDialogs = false;
      if (this.couponType == 1) {
        //加油广东
        if (index >= 0) {
          if (this.$refs.jygd[0].selItem < 0) {
            this.$error("请先选择面值");
            return;
          }
          this.chosenCoupon = index;
          this.showDialogs = false;
          this.chosenCoupon = index;
          this.$refs.jygd[0].chosenCoupon = index;
          this.$refs.jygd[0].params.card_id = this.coupons[index].id;
          this.$refs.jygd[0].$refs.payway.cname =
            "抵扣￥" + this.coupons[index].valueDesc;
        } else {
          this.$refs.jygd[0].chosenCoupon = index;
          this.$refs.jygd[0].$refs.payway.cname = "";
        }
      } else {
        //e代驾
        if (index >= 0) {
          if (this.$refs.daijia[0].selItem < 0) {
            this.$error("请先选择面值");
            return;
          }
          this.chosenCoupon = index;
          this.showDialogs = false;
          this.chosenCoupon = index;
          this.$refs.daijia[0].chosenCoupon = index;
          this.$refs.daijia[0].params.card_id = this.coupons[index].id;
          this.$refs.daijia[0].$refs.payway.cname =
            "抵扣￥" + this.coupons[index].valueDesc;
        } else {
          this.$refs.daijia[0].chosenCoupon = index;
          this.$refs.daijia[0].$refs.payway.cname = "";
        }
      }
    },
    getUserInfo() {
      this.getValidCoupons();
      this.getAllServerList();
    },
    getValidCoupons() {
      getValidCoupons(
        this.categoryId,
        this.upstreamId,
        this.buyerUserId,
        this.mouldId
      ).then((res) => {
        if (res.status == 200) {
          if(this.link == 'alipayPoints'){
            let fileList = res.data.filter((item) => item.couponsCategory.includes("alipayPoints"))
            let thisCoupon = fileList[0]
            this.couponsBalanceList = fileList.filter((item) => item.couponsWechatRedpacketRebate == thisCoupon.couponsWechatRedpacketRebate);
          }else{
            this.couponsBalanceList = res.data;
          }
        } else {
          this.$error(res.message);
        }
      });
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        done(false);
      } else {
        done();
      }
    },
    cancel() {
      this.sms = "";
    },
    sendCode() {
      this.isDisabled = true; // 防止请求网速慢时的多次点击
      getPhoneCode(this.phone.replace(/\s+/g, ""), "getcheckcode").then(
        (res) => {
          if (res.status === 1) {
            this.downTime();
            this.$success("短信验证码已发送");
          } else {
            this.isDisabled = false;
            this.$error(res.message);
          }
        }
      );
    },
    downTime() {
      let time = 59;
      let interval = setInterval(() => {
        if (time > 0) {
          let changeTime = time--;
          if (time < 10 && time > 0) {
            changeTime = "0" + time;
          }
          this.buttonText = changeTime + "秒后再获取";
        } else {
          clearInterval(interval);
          this.isDisabled = false;
          this.buttonText = "获取验证码";
        }
      }, 1000);
    },
    confirm() {
      if (this.sms == "") {
        this.$error("请输入验证码");
        return;
      }
      this.$refs.jygd[0].payOrder(this.sms, this.payData);
    },
    showDialog(i, data) {
      this.phone = i;
      this.payData = data;
      this.show = true;
    },
    getAllServerList() {
      getAllServerList().then((res) => {
        if (res.status == 1) {
          let lists = res.data.recharge_service;
          let itemIndex = lists.findIndex(
            (item) => item.link.indexOf("http") > -1
          );
          if (itemIndex > -1) {
            lists.splice(itemIndex, 1);
            itemIndex = lists.findIndex((item) => item.status == 0);
          }
          if (itemIndex > -1) lists.splice(itemIndex, 1);
          let itemIndex2 = lists.findIndex(
            (item) =>
              item.link.indexOf("/") == 0 || item.link == "" || item.link == "/"
          );
          if (itemIndex2 > -1) lists.splice(itemIndex2, 1);
          this.active = lists.findIndex(
            (item) => this.$route.query.cid == item.id
          );
          this.list = lists.map((item) => ({
            ...item,
            remark: item.link,
          }));
        } else {
          if (res.status == 10001) {
            location.replace("register");
          } else {
            this.$error(res.message);
          }
        }
      });
    },
    Onclick(name, title) {
      if (this.oldTitle == title) {
        return;
      }
      if (this.oldTitle != "") {
        this.setChecked(this.oldTitle);
      } else {
        this.setChecked(this.$route.query.ident);
      }
      this.oldTitle = title;
      this.couponsBalanceChecked = [];
      this.sell_price = 0;
      if (title == "daijia") {
        this.couponType = 2;
        if (this.$refs.daijia != undefined) {
          this.coupons = this.$refs.daijia[0].coupons;
          this.disabledCoupons = this.$refs.daijia[0].disabledCoupons;
          this.chosenCoupon = this.$refs.daijia[0].chosenCoupon;
          if (this.$refs.daijia[0].chosenCoupon > -1) {
            this.$refs.daijia[0].$refs.payway.cname =
              "抵扣￥" +
              this.coupons[this.$refs.daijia[0].chosenCoupon].valueDesc;
          } else {
            this.$refs.daijia[0].$refs.payway.cname = "";
          }
        }
      }
      if (title == "jygd") {
        this.couponType = 1;
        if (this.$refs.jygd != undefined) {
          this.coupons = this.$refs.jygd[0].coupons;
          this.disabledCoupons = this.$refs.jygd[0].disabledCoupons;
          this.chosenCoupon = this.$refs.jygd[0].chosenCoupon;
          if (this.$refs.jygd[0].chosenCoupon > -1)
            this.$refs.jygd[0].$refs.payway.cname =
              "抵扣￥" +
              this.coupons[this.$refs.jygd[0].chosenCoupon].valueDesc;
          else {
            this.$refs.jygd[0].$refs.payway.cname = "";
          }
        }
      }
      this.setBackground(title);
      this.number = -1;
    },
    //重置选中
    setChecked(val) {
      switch (val) {
        case "daijia":
          this.$refs.daijia[0].selItem = -1;
          this.$refs.daijia[0].sellData = { sell_price: -1 };
          this.$refs.daijia[0].chosenCoupon = -1;
          break;
        case "youka":
          this.$refs.youka[0].selItem = -1;
          this.$refs.youka[0].sellData = { sell_price: -1 };
          break;
        case "jygd":
          this.$refs.jygd[0].selItem = -1;
          this.$refs.jygd[0].sellData = { sell_price: -1 };
          this.$refs.jygd[0].chosenCoupon = -1;
          break;
        case "liuliang":
        case "huafei":
          for (let index = 0; index < this.$refs.mobile.length; index++) {
            this.$refs.mobile[index].selItem = -1;
            this.$refs.mobile[index].sellData = { sell_price: -1 };
          }
          break;
        case "shiping":
        case "yinpin":
        case "gouwuka":
        case "wangyou":
          this.couponsDeduct = 0;
          for (let index = 0; index < this.$refs.audio.length; index++) {
            this.$refs.audio[index].activeicon2 = -1;
            this.$refs.audio[index].sellData = { sell_price: -1 };
          }
          break;
      }
    },
    // 设置背景色
    setBackground(val) {
      switch (val) {
        case "driving":
          this.bgColor = "var(--lightGreenColor)";
          break;
        case "oilRecharge":
        case "oilGD":
          this.bgColor = "var(--redColor)";
          break;
        case "mobileBillRecharge":
        case "mobileFlowRecharge":
          this.bgColor = "var(--blueColor)";
          break;
        case "videoRecharge":
        case "musicRecharge":
        case "wangyou":
          this.bgColor = "var(--depVioletColor)";
          break;
        case "shoppingCard":
          this.bgColor = "#ecbc37";
          break;
        case "carCharging":
          this.bgColor = "#c43ac4";
          break;
        case "alipayRedPacket":
          this.bgColor = "#3a8dc4";
          break;
        case "parking":
          this.bgColor = "#1296db";
          break;
        case "inspect":
          this.bgColor = "#e98f36";
          break;
        case "lifeService":
          this.bgColor = "#FFC300";
          break;
        case "transport":
          this.bgColor = "#ec7920";
          break;
        case "onlineEducation":
          this.bgColor = "#87CEFA";
          break;
        case "weChatPoints":
          this.bgColor = "#fb7c3f";
          break;
        case "alipayPoints":
          this.bgColor = "#24a4ffe0";
          break;
      }
    },
  },
};
</script>

<style scoped lang="less">
.onLineIndex {
  .tabTitle {
    color: #fff;
    text-align: left;
    padding-top: 10px;
    font-size: 25px;
    padding-left: 20px;
  }
}
.couponsBalanceList {
  height: 65%;
  background-color: rgb(247, 248, 250);
  .van-coupon-list__list {
    overflow-y: initial;
  }
  .van-coupon {
    border: 2px solid #ff9900;
    .van-coupon__content {
      background-image: linear-gradient(-90deg, #fceabb, #f8b500);
      color: #fff;
      min-height: initial;
      padding: 10px 0;
      .van-coupon__head {
        min-width: initial;
        padding: 0 15px;
      }
    }
    .van-coupon__body {
      .van-coupon__valid {
        display: flex;
        justify-content: space-between;
        margin-right: 15px;
      }
      .van-coupon__name {
        margin-bottom: 5px;
      }
    }
    .van-coupon__description {
      padding: 15px;
      border-top: initial;
      display: flex;
      justify-content: space-between;
      .left {
        width: 90%;
        text-align: center;
        line-height: 1.5;
        .money {
          color: red;
          font-size: 14px;
          .number {
            font-size: 30px;
            font-weight: 700;
          }
        }
        .remark {
          font-size: 14px;
          color: #ccc;
        }
      }
      .right {
        display: flex;
        align-items: center;
        /deep/
          .van-checkbox__icon--disabled.van-checkbox__icon--checked
          .van-icon {
          color: #fff;
          background: #f90;
          border-color: #f90;
        }
        /deep/ .van-checkbox__icon--disabled .van-icon {
          background-color: #ddd;
          border-color: #ddd;
        }
      }
    }
  }
}
</style>
